import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const FeatureSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('feature');

    // Get the feature content data
    const featureData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section id="features" className="section features-area style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section id="features" className="section features-area style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('feature')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!featureData) {
        return (
            <section id="features" className="section features-area style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No feature content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section id="features" className="section features-area style-two overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <span className="d-inline-block rounded-pill shadow-sm fw-5 px-4 py-2 mb-3">
                                <i className="far fa-lightbulb text-primary mr-1" />
                                <span className="text-primary">{featureData.preHeading}</span> {featureData.preHeadingspan}
                            </span>
                            <h2>{featureData.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{featureData.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{featureData.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* Combine both featureData arrays to show all 6 features */}
                    {[
                        ...(featureData.featureData || []),
                        ...(featureData.featureData_1 || [])
                    ].map((item, idx) => (
                        <div key={`fo_${idx}`} className="col-12 col-md-6 col-lg-4 res-margin">
                            {/* Image Box */}
                            <div className="image-box text-center icon-1 p-5">
                                {/* Featured Image */}
                                <div className="featured-img mb-3">
                                    <img className="avatar-sm" src={item.image} alt={item.title} />
                                </div>
                                {/* Icon Text */}
                                <div className="icon-text">
                                    <h3 className="mb-2">{item.title}</h3>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;